import {Checkbox, Row} from 'antd';
import React, {FC, memo} from 'react';
import {useTerms} from '../../contexts/Quote';

const termsUrl = 'https://espace-pro.interson-protac.com/assets/cgv.pdf';

const Terms: FC = () => {
  const [terms, setTerms] = useTerms();

  return (
    <Row css={{marginBottom: 10, textAlign: 'right'}}>
      <Checkbox checked={terms} onChange={({target}) => setTerms(target.checked)}>
        <a href={termsUrl} target="_blank" rel="noopener noreferrer">
          En cliquant, vous acceptez les Conditions d&apos;utilisation
        </a>
      </Checkbox>
    </Row>
  );
};

export default memo(Terms);
